import { cn } from '@/lib/utils';
import type { MouseEvent } from 'react';

const money = new Intl.NumberFormat('en-US', { style: 'decimal', maximumFractionDigits: 0 });

interface CardTileBalanceProps {
	balance: number;
	size?: 'sm' | 'md';
	onCopy?: (text: string) => void;
	className?: string;
}

export default function CardTileBalance({ balance, size = 'md', onCopy, className }: CardTileBalanceProps) {
	function handleCopy(e: MouseEvent) {
		e.stopPropagation();
		onCopy?.(String(balance));
	}

	const sizeClass = size === 'md' ? 'text-base font-semibold' : 'text-sm font-semibold';

	if (onCopy) {
		return (
			<button
				type='button'
				className={cn(
					'tabular-nums text-destructive hover:bg-accent/60 active:bg-accent rounded-xs px-0.5 cursor-pointer select-none',
					sizeClass,
					className,
				)}
				onClick={handleCopy}
			>
				{money.format(balance)}
			</button>
		);
	}

	return (
		<span className={cn('tabular-nums text-destructive', sizeClass, className)}>{money.format(balance)}</span>
	);
}
